export default "__VITE_ASSET__BYTM7OH2__"